import styled from "styled-components";
import { motion } from "framer-motion";

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 60px;
  align-items: start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 44px;
  }
`;

export const Copy = styled(motion.div)`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const Paragraph = styled.p`
  font-size: 16px;
  line-height: 1.85;
  color: ${({ theme }) => theme.text_secondary};
`;

export const FocusChips = styled(motion.div)`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 8px;
`;

export const Chip = styled.span`
  padding: 9px 16px;
  border-radius: 100px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.09);
  color: ${({ theme }) => theme.text_primary};
  font-size: 13px;
  font-weight: 500;
  transition: border-color 0.25s ease, background 0.25s ease;

  &:hover {
    border-color: ${({ theme }) => theme.primary};
    background: rgba(139, 124, 255, 0.08);
  }
`;

export const FactList = styled(motion.div)`
  margin-top: 12px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 24px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const Fact = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 14px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
`;

export const FactLabel = styled.span`
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: ${({ theme }) => theme.text_muted};
`;

export const FactValue = styled.span`
  font-size: 15px;
  font-weight: 500;
  color: ${({ theme }) => theme.text_primary};
`;

export const StatGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
`;

export const StatCard = styled(motion.div)`
  position: relative;
  padding: 28px 22px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(255, 255, 255, 0.08);
  overflow: hidden;
  transition: transform 0.3s ease, border-color 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    border-color: rgba(139, 124, 255, 0.4);
  }
`;

export const StatValue = styled.div`
  font-family: "Space Grotesk", sans-serif;
  font-weight: 700;
  font-size: clamp(1.8rem, 3.4vw, 2.4rem);
  background: ${({ theme }) => theme.gradient};
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  letter-spacing: -0.02em;
`;

export const StatLabel = styled.div`
  margin-top: 8px;
  font-size: 13px;
  color: ${({ theme }) => theme.text_secondary};
`;
